import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import React from 'react';

export default function BomActions({ params, onDelete }) {
  return (
    <Tooltip title="刪除此明細">
      <IconButton aria-label="刪除 BOM 明細" color="error" onClick={() => onDelete(params.row)}>
        <DeleteIcon />
      </IconButton>
    </Tooltip>
  );
}
